module.exports = __webpack_public_path__ + "img/10.9254df36.png";